import axios from 'axios';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
// import InquiryService from '../../../service/inquiry/inquiry';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../../context/ModalContext';

const Limit = () => {
  // const navigate = useNavigate();
  const { modal, modalDispatch } = useModal();

  return (
    <Container
      isOpen={modal.membership}
      onClick={() => modalDispatch({ type: 'M' })}
    >
      <Ticket onClick={(e) => e.stopPropagation()}>
        <Ticket_Top>
          <Text color="#37383C9C" size={14} weight={500}>
            ※ 유료 회원만 이용가능한 서비스입니다.
          </Text>
        </Ticket_Top>
        <Ticket_Bottom>
          <Line />
          <Ticket_Bottom_Inner>
            <Ticket_Title>
              <Ticket_Title_Badge>
                <Text color="#FFFFFF" size={12} weight={700}>
                  🎉 EVENT
                </Text>
              </Ticket_Title_Badge>
              <button
                onClick={() => modalDispatch({ type: 'M' })}
                style={{
                  position: 'absolute',
                  right: '-8px',
                  top: '-8px',
                  cursor: 'pointer',
                  background: 'none',
                  border: 'none',
                }}
              >
                <img src="/assets/images/limit/close.svg" alt="" />
              </button>
            </Ticket_Title>
            <Text color="#222222" size={24} weight={700}>
              오픈 기념 무료 이벤트
            </Text>
            <img src="/assets/images/limit/Event.png" alt="" width="100%" />
            <Ticket_Confirm_Box>
              <Ticket_Confirm_Box_Wrap1>
                <Text color="#37383C9C" size={14} weight={500}>
                  140,000원
                </Text>
                <Text color="#616161" size={14} weight={500}>
                  ➜
                </Text>
                <Text color="#222222" size={14} weight={700}>
                  0원
                </Text>
              </Ticket_Confirm_Box_Wrap1>
              <Ticket_Confirm_Button
                onClick={() =>
                  // navigate('/promotion/땅집고옥션-오픈기념-이벤트')
                  {
                    window.location.pathname =
                      '/promotion/땅집고옥션-오픈기념-이벤트';
                    modalDispatch({ type: 'M' });
                  }
                }
              >
                <Text color="#FFFFFF" size={16} weight={500}>
                  0원 혜택받기
                </Text>
              </Ticket_Confirm_Button>
              <Text color="#386CCB" size={13} weight={700}>
                14만원 상당의 멤버십을 지금 무료로 이용해보세요!
              </Text>
            </Ticket_Confirm_Box>
          </Ticket_Bottom_Inner>
        </Ticket_Bottom>
      </Ticket>
    </Container>
  );
};

export default Limit;

const Limit2 = () => {
  return (
    <Container>
      <Ticket>
        <Ticket_Top>
          <Ticket_Bottom_Inner>
            <Text color="#222222" size={18} weight={700}>
              유료 멤버십 회원만 확인 가능합니다.
            </Text>
            <Membership_Box>
              <Text color="#000000" size={14} weight={500}>
                내 멤버십 등급
              </Text>
              <Membership_Badge>
                <Text color="#FFFFFF" size={14} weight={700}>
                  Free
                </Text>
              </Membership_Badge>
            </Membership_Box>
            <Text color="#616161" size={16} weight={500}>
              멤버십을 업그레이드하고
              <br />
              경매 투자 성공률을 높혀보세요!
            </Text>
            <Membership_Container>
              <Membership_Button2>
                <Text color="#008AFF" size={16} weight={500}>
                  닫기
                </Text>
              </Membership_Button2>
              <Membership_Button1>
                <Text color="#FFFFFF" size={16} weight={500}>
                  멤버십 보러가기
                </Text>
              </Membership_Button1>
            </Membership_Container>
          </Ticket_Bottom_Inner>
        </Ticket_Top>
      </Ticket>
    </Container>
  );
};

// export default Limit2;

const Container = styled.div<{ isOpen?: boolean }>`
  background: #00000085;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  justify-content: center;
  align-items: flex-end;
  display: none;
  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
`;

const Text = styled.span<{ color: string; size: number; weight: number }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: ${(props) => props.weight};
  font-size: ${(props) => props.size}px;
  line-height: 145%;
  letter-spacing: ${(props) => props.size * -0.02}px;
  text-align: center;
  color: ${(props) => props.color};
`;

const Ticket = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Ticket_Top = styled.div`
  width: 100%;
  border-radius: 16px;
  padding: 24px;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Ticket_Bottom = styled.div`
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 0 24px 40px;
  display: flex;
  flex-direction: column;
  gap: 22x;
  align-items: center;
  background: #ffffff;
`;

const Ticket_Bottom_Inner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

const Line = styled.div`
  width: calc(100% - 64px);
  height: 2px;
  background-image: repeating-linear-gradient(
    to right,
    #e5e8ea 0,
    #e5e8ea 8px,
    transparent 8px,
    transparent 10px
  );
  margin-bottom: 22px;
`;

const Ticket_Title = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  position: relative;
`;

const Ticket_Title_Badge = styled.div`
  padding-top: 6px;
  padding-right: 10px;
  padding-bottom: 6px;
  padding-left: 10px;
  border-radius: 6px;
  background: #222222;
`;

const Ticket_Confirm_Box = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const Ticket_Confirm_Box_Wrap1 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const Ticket_Confirm_Button = styled.button`
  width: 100%;
  border-radius: 8px;
  padding: 12px 0;
  background-color: #008aff;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Membership_Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const Membership_Button1 = styled.button`
  width: 50%;
  border-radius: 8px;
  padding: 14px 0;
  background-color: #008aff;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Membership_Button2 = styled.button`
  width: 50%;
  border-radius: 8px;
  padding: 14px 0;
  background-color: #e8f1ff;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Membership_Box = styled.div`
  padding-top: 8px;
  padding-right: 24px;
  padding-bottom: 8px;
  padding-left: 24px;
  gap: 6px;
  border-radius: 9999px;
  background: #f7f8fc;
  display: flex;
  flex-direction: row;
`;

const Membership_Badge = styled.div`
  padding-top: 2px;
  padding-right: 8px;
  padding-bottom: 2px;
  padding-left: 8px;
  border-radius: 4px;
  border-width: 2px;
  background: linear-gradient(105.88deg, #c4c6cc 0%, #85898e 100%);
  border: 2px solid linear-gradient(94.45deg, #e0e1e6 0%, #bdc1c7 100%);
`;
